import { useEffect, useState } from "react";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import MultiSelectSimple from "../../../../../../../../../../components/dinamicForm/multiSelectSimple";
import { ConfirmModal } from "../../../../../main/components";
import { useTranslation } from "react-i18next";
import { useReassingModal } from "./styles";
import { useReportFoliosDetailContext } from "../../../../hooks/useReportFoliosContext";
import { Item, ObjectGeneric, onChangeEvent } from "../../../../../../../../../../utils/types/generals";
import { reportFolioServices } from "../../../../../../../../../../utils/constants/callService"
import { useParams } from "react-router-dom";
import { handleAllErrors } from "../../../../../../../../../../utils/methods/handleErrors"
import { Types } from "../../../../../../../../../../utils/enums"
import { useGetData } from "../../../../hooks/useGetData";
import { DepartmentUser } from "../../../../../main/hooks/types";


interface ReassignModalProps {
  open: boolean;
  onClose: () => void;
  refresh: () => void;
}

export const ReassignProviderModal = ({ open, onClose, refresh }: ReassignModalProps) => {
  const { t } = useTranslation();
  const { id } = useParams()
  const styles = useReassingModal();
  const { data } = useGetData({ id })
  const { setSnackbar } = useReportFoliosDetailContext();

  const [selectedProvider, setSelectedProvider] = useState<ObjectGeneric | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [items, setItems] = useState<Item[]>([]);

  const departmentId = data.left?.departmentId

  const handleProviderChange = (e: onChangeEvent) => {
    setSelectedProvider(e.target.value);
  };

  useEffect(() => {
    const getProviders = async () => {
      if (!departmentId) {
        return;
      }
      try {
        let query = `all=false&department_selected_ids=${departmentId}`

        const response = await reportFolioServices.getDepartmentsWithFoliosIds({ query }) as DepartmentUser[];

        const transformedData = response.map((item: DepartmentUser) => ({
          label: `${item.firstName} ${item.lastName}`,
          value: item.id,
          id: item.id.toString()
        }));

        setItems(transformedData);
      } catch (error) {
        console.log(error)
      }
    }
    getProviders();
  }, [departmentId])

  const handleSubmit = async () => {
    const folioIds = id ? [Number(id)] : [];
    const payload = {
      user_asign_id: selectedProvider?.value,
      all: false,
      folio_ids: folioIds,
      not_folio_ids: []
    };

    try {
      const response = await reportFolioServices.reassignFolio(payload)
      const code = response?.errors?.[0]?.code

      if (code) {
        setSnackbar({
          open: true,
          message: handleAllErrors(code, t, ''),
          type: Types.ERROR
        })
        return false
      }

      setSnackbar({
        open: true,
        message: t('reportFolio.detail.reassignProviderSucces.message.edit'),
        type: Types.SUCCESS
      })
      setSelectedProvider(null);
      return true
    } catch (error) {
      return false
    }
  }

  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="reassign-modal">
        <Box sx={styles.container}>
          <Typography variant="h6" component="h2" textAlign="center">
            {t('reportFolio.detail.general.reassignProvider')}
          </Typography>

          <Typography variant="body2" textAlign="center">
            {t('reportFolio.detail.general.selectAndConfirm')}
          </Typography>

          <Stack spacing={2} sx={{ mt: 2 }}>
            <MultiSelectSimple
              isRequired
              errors={null}
              name="providerId"
              label={t('reportFolio.detail.general.providerForm')}
              onChange={handleProviderChange}
              items={items}
              selected={selectedProvider}
            />

            <Stack direction="row" spacing={2} justifyContent="space-between" mt={4}>
              <Button variant="text" color="primary" onClick={onClose}>
                {t('reportFolio.detail.general.cancel')}
              </Button>
              <Button
                variant="contained"
                onClick={() => setConfirmModalOpen(true)}
                disabled={!selectedProvider}
                sx={styles.button}
              >
                {t('reportFolio.detail.general.reassing')}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={async () => {
          const success = await handleSubmit();
          if (success) {
            refresh();
            onClose();
          }
        }}
        title="Confirmación"
        description={t('reportFolio.detail.general.reassignProviderConfirm')}
      />
    </>
  );
};